<template>
  <div class="all_discuss_wrap">
    <div class="all_discuss_title">
      <div class="all_discuss_tab">
        <img src="../../../../../../../static/images/study/icon/luntan_hv.png"/>
        <h2>{{currentRouter}}</h2>
      </div>
      <div class="all_discuss_title_right">
        <div v-if="currentRouter=='全部讨论区'">
          <div class="discuss_search">
            <el-input v-model="discussSearchValue" @keyup.enter.native="discussSearch" placeholder="请输入讨论主题、回复或评论"></el-input>
            <el-button icon="el-icon-search" @click="discussSearch"></el-button>
          </div>
          <el-button class="send_discuss" @click="addDiscuss">发起讨论</el-button>
        </div>
        <div v-if="currentRouter!='全部讨论区'">
          <el-button class="send_discuss" @click="backBiscuss">返 回</el-button>
        </div>
      </div>
    </div>
    <discussList
     v-if="currentRouter=='全部讨论区'" 
     :discussList="discussList" 
     :introduce="introduce" 
     :isOwnValue="ownValue" 
     :region="region" 
     :pageTotal="pageTotal"
     v-on:toClass="listSwitch" 
     v-on:changeSwitch="changeSwitch" 
     v-on:jumpDetails="jumpDetails" 
     @currentPageFn="currentPageFn"
     ></discussList>
    <initiateDiscussion
     v-if="currentRouter=='发起讨论'||currentRouter=='编辑讨论'" 
     :region="detailsRegion" 
     :isTopNum="isTopNum" 
     :editDetailsInfo="editDetailsInfo" @publish="publish"></initiateDiscussion>
    <themeDetails
     v-if="currentRouter=='主题详情'&&detailsId!=null" 
     @changeRouter="changeRouter" 
     :region="detailsRegion" :detailsId="detailsId"></themeDetails>
  </div>
</template>
<script>
import discussList from '../component/discussList'
import initiateDiscussion from '../component/initiateDiscussion'
import themeDetails from '../component/themeDetails'
import * as api from "../../../../../../api/discussApi";
export default {
  inject: ['reload'],
  components: {
    discussList,
    initiateDiscussion,
    themeDetails
  },
  data() {
    return {
      currentRouter: '全部讨论区',
      introduce: '欢迎大家来到讨论区！本讨论区供各位同学就课程问题进行交流学习。希望老师解答的疑问，请发到老师答疑区；与课程相关的想法、创意及疑问等，请发到课堂交流区。',
      discussList:[],
      discussSearchValue: '',
      ownValue: false,
      editRouter: '',
      listType: 0,
      isTopNum: 0,
      region: 'all',
      detailsRegion: 'all',
      detailsId: null,
      editDetailsInfo: null,
      pageTotal: {
        currentpage: 1,
        pageSize: 10,
        total: 0
      },
      repliedOrParticipationFlag: 0
     }
  },
  watch: {
    detailsId:function(val){
      // console.log(val)
    },
    editDetailsInfo:function(val){
      // console.log(val)
    }
  },
  mounted() {
    this.getDiscussList(1)
  },
  methods: {
    getDiscussList(currentpage){
      let obj = {
        courseId: this.$route.query.id,
        classId: this.$route.query.classId,
        type: this.listType,
        name: this.discussSearchValue,
        catalogId: null,
        myContent: this.ownValue, //只看我的
        repliedOrParticipationFlag: this.repliedOrParticipationFlag, //老师已答复、参与
        discussionAreaId: 1, //1全部、2老师、3课堂
        pageSize: this.pageTotal.pageSize,
        pageNum: currentpage
      }
      api.getDiscussList(obj).then(rs=>{
        if(rs.code==0){
          this.discussList = rs.data.list
          this.pageTotal = {
            currentpage: rs.data.pageNum,
            pageSize: rs.data.pageSize,
            total: rs.data.total
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    changeRouter(val){
      this.currentRouter = val.router
      this.region = val.region
      this.editDetailsInfo = val.item
      this.detailsRegion = val.region
    },
    addDiscuss(){
      this.currentRouter = '发起讨论'
      this.editDetailsInfo = null
      let count = 0
      this.discussList.forEach((v,i)=>{
        if(v.roofPlacement){
          count++
        }
      })
      this.isTopNum = count
    },
    discussSearch(){
      this.getDiscussList(1)
    },
    listSwitch(index){
      this.listType = index
      this.getDiscussList(1)
    },
    changeSwitch(val){
      this.ownValue = val.ownValue
      this.getDiscussList(1)
    },
    backBiscuss(){
      if(this.currentRouter=='主题详情'){
        this.currentRouter = '全部讨论区'
        this.reload()
      }else if(this.currentRouter=='发起讨论'){
        this.currentRouter = '全部讨论区'
        this.reload()
      }else if(this.currentRouter=='编辑讨论'){
        this.currentRouter = '主题详情'
      }
    },
    currentPageFn(val){
      this.pageTotal.currentPage = val;
      this.getDiscussList(val)
    },
    jumpDetails(val){
      this.currentRouter = val.router
      this.detailsRegion = val.region
      this.detailsId = val.item.id
      // let detailsObj = {
      //   id: val.item.id,
      //   courseId:this.$route.query.id,
      //   classId:this.$route.query.classId,
      // }
      // this.$ajax.post('/api-study/discussion/getDiscussionAndReply',detailsObj).then(rs=>{
      //   if(rs.data.code==0){
      //     this.detailsInfo = rs.data.data
      //   }else{
      //     this.$messageError(rs.data.msg)
      //   }
      // }).catch(err=>{
      //   console.log(err)
      // })
      let obj = {
      	learnId: val.item.id,
        type: 0
      }
      api.getDiscussDetail(obj).then(rs=>{
        // console.log(rs)
      }).catch(err=>{
        console.log(err)
      })
    },
    publish(){
      this.backBiscuss()
    }
  },
}
</script>
<style lang="scss">
  .all_discuss_wrap{
    height: 100%;
    .all_discuss_title{
      height: 48px;
      border-bottom: 1px solid #E6E6E6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 24px;
      box-sizing: border-box;
      .all_discuss_tab{
        display: flex;
        img{
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
        h2{
          font-size:18px;
          font-weight:400;
          color:rgba(51,51,51,1);
          span{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            cursor: pointer;
            i{
              &:hover{
                color: #5397F7;
              }
            }
          }
        }
      }
      .all_discuss_title_right{
        display: flex;
        div{
          display: flex;
          .discuss_search{
            display: flex;
            .el-input{
              width: inherit;
            }
            input{
              width:200px;
              height:30px;
              border-radius: 4px 0 0 4px;
              font-size: 12px;
            }
            button{
              width:40px;
              height:30px;
              background:rgba(83,151,247,1);
              border-radius:0px 4px 4px 0px;
              padding: 0;
              border: none;
              i{
                color: #fff;
              }
            }
          }
        }
        .send_discuss{
          padding: 0 16px;
          min-width: 72px;
          max-width: 80px;
          height:30px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          margin-left: 16px;
          color: #5397F7;
          font-size: 12px;
          box-sizing: border-box;
          text-align: center;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/discuss/allDiscuss/allDiscuss.vue